import EventBus from "@plugins/common/service/eventbus";

const toastEventBus = new EventBus();

export default toastEventBus;
